import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "menu", "button" ]

  toggle() {
    this.menuTarget.classList.toggle("open")
    this.syncExpanded()
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.remove("open")
      this.syncExpanded()
    }
  }

  syncExpanded() {
    if (!this.hasButtonTarget) return

    this.buttonTarget.setAttribute("aria-expanded", this.menuTarget.classList.contains("open"))
  }
}
